import React, { Component } from 'react';
import propsTypes from 'prop-types';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Alert } from 'react-bootstrap';

class Info extends Component {

  constructor(props) {
    super(props);
    this.state = {
      to_date: '2100-1-1',
    };
    this.toPay = this.toPay.bind(this);
  }

  toPay() {
    this.props.history.push('/pay');
  }

  componentWillReceiveProps(nextProps) {
    if (Object.keys(nextProps.validity).length !== 0) {
      this.setState({'to_date':moment(nextProps.validity[0]['to_date']).format('YYYY-MM-DD')});
    }
  }

  render() {
    var days = 36135;
    if ('token' in this.props.userinfo) {
      if (this.state.to_date !== null) {
        days = moment(this.state.to_date,"YYYY-MM-DD").diff(moment(),'days');
      }
    }
    return (
      (days >= 10) ? 
        ('') 
        : 
        ( 
          (days > 0) ?
            (<Alert bsStyle="warning">您的账户将于<b>{this.state.to_date}</b>到期，请及时<a nohref="true" onClick={this.toPay}>充值</a>。</Alert>)
          :
            (<Alert bsStyle="warning">您的账户已过有效期，需<a nohref="true" onClick={this.toPay}>充值</a>后才可继续输入错题。</Alert>)
        ) 
    )
  }
}

Info.propsTypes = {
  userinfo: propsTypes.object,
  validity: propsTypes.object,
}

const mapStateToProps = state => ({
  userinfo: state.users.item,
  validity: state.validity.item,
})

export default withRouter(
  connect(
    mapStateToProps,
  )(Info));


// WEBPACK FOOTER //
// ./src/components/Info.js